import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { DavidN_Video3 } from '../../../../../utils/EN/Modals/aiArtists';

const ModalVideoDavidN3 = () => {
  return (
    <>
      <ModalVideo
        id="david-n-video-3"
        dataText={DavidN_Video3}
        videoSrc="https://www.youtube.com/embed/c9jutVLZEGg?si=A2O3Shu6ALQNUV_j"
        videoTitle="KUTER_STUDIO_AI_DAVID_N_VIDEO_3"
      />
    </>
  );
};

export default ModalVideoDavidN3;
